/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
import{s}from"../../../../../chunks/vec32.js";import{create as r}from"../../../../../core/libs/gl-matrix-2/factories/vec3f64.js";import{a as e,g as o,h as t}from"../../../../../chunks/boundedPlane.js";function a(r,e){return o(e.extent,c),t(c,s(n,r.x,r.y,0))}const c=e(),n=r();export{a as distanceToTile};
